export default __webpack_public_path__ + "static/map-941ae58140e1107cef25b36ff1a83ed5.png";